<template>
  <v-container fluid>
        <!-- editor -->
        <editor
          :initial="dataItem"
        ></editor>
        <!-- end -->
    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
import Editor from "../_components/editor.vue";
export default {
  components: {
    Editor,
  },
  data: () => ({
    dataItem: {},
    docCreate: false,
    copyStatus: false
  }),
  watch: {
    "$route.params.id": {
      handler: "getById",
      immediate: true,
    },
  },
  methods: {
    getById(val) {
      const self = this;
      // get record
      this.$store
        .dispatch("get", `/sales-invoice/${val}`)
        .then((res) => {
          console.log(res, " invoice response");
          if (res.ResultCode == 1200) {
            self.dataItem = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
};
</script>